import { useState } from "react";
import { parseInviteFragment } from "@psplit/ledger-core";
import { repo } from "../lib/repo.js";
import { navigate } from "../lib/hooks.js";
import { syncGroup } from "../lib/relaySync.js";
import { errorMessage } from "../lib/errors.js";

export function Join({ fragment }: { fragment: string }) {
  const [error, setError] = useState("");
  const invite = parseInviteFragment(fragment);

  if (!invite) {
    return (
      <div className="page center">
        <h2>Invalid invite</h2>
        <p className="muted">This link is not a valid PaisaSplit invite.</p>
        <button className="btn" onClick={() => navigate("#/")}>
          Go home
        </button>
      </div>
    );
  }

  const accept = async () => {
    setError("");
    try {
      await repo.joinGroup(invite);
      navigate(`#/g/${invite.groupId}/sync`);
      if (invite.relayUrl !== "") void syncGroup(invite.groupId);
    } catch (e) {
      setError(errorMessage(e));
    }
  };

  return (
    <div className="page center">
      <h2>Join “{invite.name === "" ? "a group" : invite.name}”?</h2>
      <p className="muted">
        {invite.relayUrl !== ""
          ? "This group syncs through an encrypted relay. After joining, a current member's device admits you automatically on their next sync."
          : "This group syncs face-to-face with QR codes. After joining, show your join QR to a member."}
      </p>
      <div className="row gap">
        <button className="btn primary" onClick={() => void accept()}>
          Join group
        </button>
        <button className="btn" onClick={() => navigate("#/")}>
          Not now
        </button>
      </div>
      {error !== "" && <div className="error">{error}</div>}
    </div>
  );
}
